var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicationsCount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.816,
    height: 15.816,
    viewBox: "0 0 15.816 15.816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_folder-open",
    "data-name": "vuesax/outline/folder-open",
    transform: "translate(-492 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-open",
    transform: "translate(492 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.023,8.238H2.733C.492,8.238.373,7.005.274,6.01l-.264-3.3A2.5,2.5,0,0,1,.545.916,2.465,2.465,0,0,1,2.469,0h8.818a2.462,2.462,0,0,1,1.891.883l.112.152a2.43,2.43,0,0,1,.455,1.68L13.481,6C13.382,7.005,13.264,8.238,11.023,8.238ZM2.469.989a1.467,1.467,0,0,0-1.14.54l-.046.046A1.481,1.481,0,0,0,1,2.623l.264,3.3c.092.962.132,1.325,1.47,1.325h8.29c1.344,0,1.377-.362,1.47-1.331l.264-3.3a1.437,1.437,0,0,0-.33-1.081l-.066-.079A1.468,1.468,0,0,0,11.28.989Z",
    transform: "translate(1.03 6.755)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M11.7,7.21a.5.5,0,0,1-.494-.494V5.536c0-1.964-.343-2.307-2.307-2.307H7.216A1.351,1.351,0,0,1,5.931,2.59l-.85-1.127A.872.872,0,0,0,4.132.989H3.3C1.331.989.989,1.331.989,3.3V6.689a.5.5,0,0,1-.494.494A.5.5,0,0,1,0,6.689V3.3C0,.771.771,0,3.3,0h.844a1.794,1.794,0,0,1,1.74.87l.844,1.12c.178.237.191.25.5.25H8.9c2.524,0,3.3.771,3.3,3.3v1.18A.508.508,0,0,1,11.7,7.21Z",
    transform: "translate(1.812 0.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M3.882.989H.494A.5.5,0,0,1,0,.494.5.5,0,0,1,.494,0H3.882a.494.494,0,1,1,0,.989Z",
    transform: "translate(5.72 10.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H15.816V15.816H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsCount);
export default __webpack_public_path__ + "static/media/applications_count.a5d12a31ab3780b5a25a6fc4a1cdab50.svg";
export { ForwardRef as ReactComponent };